export interface Props {
  color: string;
  hoverColor: string;
}

const Facebook = ({ color, hoverColor }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={`size-5 lg:size-6 text-${color} duration-300 ease-in-out fill-current hover:text-${hoverColor}`}
    >
      <path
        fill=""
        d="M9.364 13.522V21h3.976v-7.478h2.966l.617-3.438H13.34V8.868c0-1.818.696-2.514 2.493-2.514.558 0 1.007.014 1.268.042V3.278C16.611 3.14 15.411 3 14.72 3c-3.665 0-5.355 1.775-5.355 5.604v1.48H7.1v3.438h2.263Z"
      />
    </svg>
  );
};

export default Facebook;
